import { gql } from '@apollo/client';

export type TtLocationConfigItem = {
  id: number;
  parentId: number | null;
  locationType: number;
  code: string;
  name: string;
  labelCode: string | null;
  sortOrder: number | null;
  updatedBy?: string | null;
};

export type TtLocationConfigFilterInput = {
  locationType?: number;
  parentId?: number;
  name?: string;
  isDeleted?: boolean;
};

export type TtLocationConfigPageResponse = {
  getTtLocationConfigsWithPagination: {
    content: TtLocationConfigItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
};

export type TtLocationConfigChildrenResponse = {
  getTtLocationConfigChildren: TtLocationConfigItem[];
};

export const GET_TT_LOCATION_CONFIGS_WITH_PAGINATION = gql`
  query GetTtLocationConfigsWithPagination(
    $filter: TtLocationConfigFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    getTtLocationConfigsWithPagination(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        parentId
        locationType
        code
        name
        labelCode
        sortOrder
        updatedBy
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_TT_LOCATION_CONFIG_CHILDREN = gql`
  query GetTtLocationConfigChildren($parentId: Long!) {
    getTtLocationConfigChildren(parentId: $parentId) {
      id
      parentId
      locationType
      code
      name
      labelCode
      sortOrder
    }
  }
`;
